import { DRIVER_DOCUMENT_FILES } from "@repo/types";

/** Form slots for the driver's files, in the shared display order. */
const DRIVER_DOCS = DRIVER_DOCUMENT_FILES.map((file) => ({
  id: file.name,
  key: file.name,
  label: file.label,
  documentId: file.documentId,
  type: file.kind === "image" ? "image" : "pdf",
  url: "",
}));
export default DRIVER_DOCS;
